import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Afficher la configuration au démarrage
// console.log('=== LIGDI CONFIG ===')
// console.log('API Base URL:', import.meta.env.VITE_API_BASE_URL)
// console.log('API Timeout:', import.meta.env.VITE_API_TIMEOUT)
// console.log('API Mode:', import.meta.env.VITE_API_MODE)
// console.log('===================')

ReactDOM.createRoot(document.getElementById('rootLigdi')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
